export default _this => {
  _this.columns = [
    "name",
    "users",
    "policy",
    "usersActive",
    "jobs",
    "total",
    "black",
    "color",
    "prints",
    "copies",
    "scans"
  ];
  _this.data = [];
  let policies = [];
  if (_this.user.settings && _this.user.settings.groups) {
    const { groups, policies: userPolicies } = _this.user.settings;
    for (const groupId of Object.keys(groups)) {
      const group = groups[groupId];
      const policyId = group.policy;

      let policy = {};
      if (userPolicies && policyId && userPolicies[policyId]) {
        policy = userPolicies[policyId];
      }

      const row = {
        DT_RowId: groupId,
        name: group.name,
        policy: policy.name
      };
      _this.data.push(row);
    }
    policies = Object.keys(userPolicies || {}).map(key => {
      const { name } = userPolicies[key];
      return {
        label: name,
        value: key
      };
    });
  }
  policies = [{ label: "", value: "" }, ...policies];

  $.each(_this.unique(_this.columns), (index, column) => {
    let title = column;
    let uniqueColumn = { data: column };
    let visible = true;
    uniqueColumn["title"] = _this.t(title);
    uniqueColumn["visible"] = visible;
    uniqueColumn["name"] = column;
    if (
      [
        "users",
        "usersActive",
        "jobs",
        "total",
        "black",
        "color",
        "prints",
        "copies",
        "scans"
      ].includes(column)
    ) {
      uniqueColumn["defaultContent"] = 0;
    }
    if (column === "usersActive") {
      uniqueColumn["title"] = "Active Users";
    }
    _this.uniqueColumns.push(uniqueColumn);
  });

  const { /* columns,  */ options } = _this.createTableProperties(_this);
  _this.table = $(_this.$el)
    .find("table")
    .DataTable(options);
  const fields = [
    {
      label: `${_this.t("Name")}`,
      name: "name"
    },
    {
      label: `${_this.t("Policy")}`,
      name: "policy",
      type: "select",
      def: "",
      ipOpts: policies
    }
  ];

  const ajax = (method, url, d, success, error) => {
    let output = { data: [] };
    switch (d.action) {
      case "create":
        const group = d.data[0];
        const groupId = _this.uuidv4();
        const update = {};
        update[`settings.groups.${groupId}`] = JSON.parse(
          JSON.stringify(group)
        );
        group.DT_RowId = groupId;
        output.data.push(group);
        success(output);
        _this.$store.state.db
          .collection("users")
          .doc(_this.ref.id)
          .update(update)
          .then(() => {
            applyGroupsRangeDate(_this.startDate, _this.endDate);
          });
        break;
      case "edit": {
        (async () => {
          const update = {};
          for (const id of Object.keys(d.data)) {
            const value = d.data[id];
            const rowData = _this.table.row("#" + id).data();
            const data = $.extend({}, rowData, value);
            const newData = $.extend({}, _this.user.settings.groups[id], value);
            update[`settings.groups.${id}`] = newData;
            output.data.push(data);
          }
          success(output);
          try {
            await _this.$store.state.db
              .collection("users")
              .doc(_this.ref.id)
              .update(update);
          } catch (e) {
            console.log(e);
          }
        })();
        break;
      }
      case "remove":
        success(output);
        async.eachOf(
          d.data,
          (value, id, callback) => {
            // const update = {};
            // update[
            //   `settings.groups.${id}`
            // ] = _this.firebase.firestore.FieldValue.delete();
            // todo: check if users exists with the same group and prevent deleting the group if yes.
            // _this.$store.state.db
            //   .collection("users")
            //   .doc(_this.ref.id)
            //   .update(update)
            //   .then(() => callback());
          },
          error => {
            // todo: check if users exists with the same group and prevent deleting the group if yes.
          }
        );
        break;
    }
  };
  const editor = _this.createEditor(_this, fields, ajax);
  const buttons1 = [
    {
      extend: "create",
      editor,
      text: '<span class="icon s7-plus"></span>',
      titleAttr: _this.t("Add"),
      formTitle: (editor, dt) => editor.i18n.create.title
    },
    {
      extend: "edit",
      editor: editor,
      text: '<span class="icon s7-pen"></span>',
      titleAttr: _this.t("Edit"),
      formTitle: (editor, dt) => editor.i18n.edit.title
    },
    {
      extend: "remove",
      editor,
      text: '<span class="icon s7-trash"></span>',
      titleAttr: _this.t("Remove")
    }
  ];
  const buttons2 = [];
  _this.createButtons(_this, buttons1, buttons2);

  const tableId = _this.table
    .containers()[0]
    .getAttribute("id")
    .split("_")[2];

  $(`<div class="dt-buttons btn-group dt-header-buttons right">
            <div id="groups-date-range" class="date-range" style="background: #fff; cursor: pointer; border: 1px solid #ccc; padding: 0 10px; padding-right: 6px;">
            <i class="icon s7-date"></i>&nbsp;
            <span></span> <i class="fa fa-caret-down"></i>
        </div>
    </div>`).prependTo(`#DataTables_Table_${tableId}_wrapper`);

  const groupsDateRangeCb = (start, end) => {
    $("#groups-date-range span").html(
      start.format("ll") + " - " + end.format("ll")
    );
  };

  $("#groups-date-range").daterangepicker(
    {
      startDate: _this.startDate,
      endDate: _this.endDate,
      ranges: _this.ranges,
      opens: "left"
    },
    groupsDateRangeCb
  );

  groupsDateRangeCb(_this.startDate, _this.endDate);

  const applyGroupsRangeDate = async (startDate, endDate) => {
    _this.table.processing(true);
    // todo: get clients usage together with groups and clients settings and merge them together for this
    const users = _this.clients.map(client => client.snapshot.id);
    const clientsResponse = await _this.serviceRequest("getClientsUsage", {
      users,
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD")
    });
    const clients = _this.arrayToObject(clientsResponse, [
      /* "user",  */ "client"
    ]);
    let clientSettings = {};
    if (_this.user.settings && _this.user.settings.clients) {
      clientSettings = _this.user.settings.clients;
    }

    const groups = {};
    for (const clientId of Object.keys(clientSettings)) {
      const currentClientSettings = clientSettings[clientId];
      const { group: groupId } = currentClientSettings;
      if (groupId && !groups[groupId]) {
        groups[groupId] = {
          users: 0,
          usersActive: 0,
          jobs: 0,
          total: 0,
          black: 0,
          color: 0,
          prints: 0,
          copies: 0,
          scans: 0
        };
      }
      if (groups[groupId]) {
        groups[groupId].users += 1;
        const currentClient = clients[clientId];
        if (currentClient) {
          const {
            jobs,
            total,
            black,
            color,
            prints,
            copies,
            scans
          } = currentClient;
          if (jobs > 0) {
            groups[groupId].usersActive += 1;
          }
          groups[groupId].jobs += jobs;
          groups[groupId].total += total;
          groups[groupId].black += black;
          groups[groupId].color += color;
          groups[groupId].prints += prints;
          groups[groupId].copies += copies;
          groups[groupId].scans += scans;
        }
      }
    }

    _this.table.data().map(value => {
      const groupId = value.DT_RowId;
      const group = groups[groupId];
      if (group) {
        _this.table
          .row((idx, data) => data.DT_RowId === value.DT_RowId)
          .data(Object.assign(value, group));
      } else {
        _this.table
          .row((idx, data) => data.DT_RowId === value.DT_RowId)
          .data(
            Object.assign(value, {
              usersActive: 0,
              jobs: 0,
              total: 0,
              black: 0,
              color: 0,
              prints: 0,
              copies: 0,
              scans: 0
            })
          );
      }
    });

    _this.table
      .column("total:name")
      .order("desc")
      .draw();
    _this.table.processing(false);
  };

  $("#groups-date-range").on("apply.daterangepicker", (event, picker) => {
    event.preventDefault();
    const { startDate, endDate } = picker;
    applyGroupsRangeDate(startDate, endDate);
  });

  applyGroupsRangeDate(_this.startDate, _this.endDate);
};



// WEBPACK FOOTER //
// ./src/mixins/Groups.js